import { API } from "./utils"


export const rights = {
  rightsList: () => API.get("/rights/"),
  useTypesList: () => API.get("/use_types/")
} 